import React from "react";
import PropTypes from "prop-types";
import RoleRequirements from "./RoleRequirements";
import Card from "components/Card";
import { Grid } from "components/Containers";
import RoleQuestionnaire from "./RoleQuestionnaire";
import RoleCodeChallenges from "./RoleCodeChallenges";
import RoleInterviewQuestions from "./RoleInterviewQuestions";

/**
 * RoleVetting
 *
 * @param {Object}  role
 * @param {Boolean} loading
 */
const RoleVetting = ({ role, loading, ...props }) => (
  <>
    <Grid>
      <Grid.col start={1} end={13}>
        <Card>
          <RoleRequirements missionRole={role} loading={loading} {...props} />
        </Card>
      </Grid.col>
      <Grid.col start={1} end={13}>
        <Card>
          <RoleQuestionnaire missionRole={role} loading={loading} {...props} />
        </Card>
      </Grid.col>
      <Grid.col start={1} end={13}>
        <Card>
          <RoleCodeChallenges data={role} loading={loading} dataTableView {...props} />
        </Card>
      </Grid.col>
      <Grid.col start={1} end={13}>
        <Card>
          <RoleInterviewQuestions missionRole={role} />
        </Card>
      </Grid.col>
    </Grid>
  </>
);

RoleVetting.propTypes = {
  role: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default RoleVetting;
